module.exports = __webpack_public_path__ + "cardRegalendario.d982daa3847f8897e4aef054541f659c.png";